(function(){
  function fixMaLayout(){
    if(window.innerWidth > 749) return;
    var container = document.querySelector('.ma-legal, .ma-faq-wrap');
    if(!container) return;
    var el = container;
    for(var i = 0; i < 10; i++){
      el = el.parentElement;
      if(!el || el === document.body) break;
      var cs = window.getComputedStyle(el);
      var isGrid = cs.display === 'grid';
      var isHorizFlex = cs.display === 'flex' && cs.flexDirection !== 'column' && el.children.length >= 2;
      if(isGrid || isHorizFlex){
        el.style.cssText += ';display:block!important;';
        [].forEach.call(el.children, function(c){
          if(c.contains(container)){
            c.style.cssText += ';width:100%!important;max-width:100%!important;min-width:0!important;';
          } else {
            c.style.display = 'none';
          }
        });
        break;
      }
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', fixMaLayout);
  } else {
    fixMaLayout();
  }
})();
